<template>
  <div
    :class="[
      'dropdown',
      {
        'dropdown-left': position === 'left',
        'dropdown-top': position === 'top',
        'dropdown-right': position === 'right',
        'dropdown-hover': hover,
        'dropdown-open': opened,
        'dropdown-end': align === 'end',
      },
    ]"
  >
    <!--Possible issue in safari https://daisyui.com/components/dropdown/-->
    <m-button :icon="faCaretDown" :theme="theme" @click="opened = !opened"><slot /></m-button>

    <m-drop-down-content @close="close()">
      <slot name="content" :close="close"></slot>
    </m-drop-down-content>
  </div>
</template>
<script lang="ts" setup>
  import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
  import { ref } from 'vue';
  import type { MButton_ThemeProp } from '@core/components/MButton';
  import MDropDownContent from './MDropDownContent.vue';

  export interface Props {
    align?: 'end' | 'start';
    position?: 'top' | 'left' | 'right' | 'bottom';
    hover?: boolean;
    theme?: MButton_ThemeProp;
  }
  withDefaults(defineProps<Props>(), { position: 'bottom', hover: false, align: 'start', theme: 'primary' });
  const opened = ref(false);
  const close = () => (opened.value = false);
</script>
